export const CHANGE_YOUR_PLAN = 'change_your_plan';
export const EDIT_ADDONS = 'edit_addons';
export const CHANGE_PAYMENT_METHOD = 'change_payment_method';
